import { createUseStyles } from 'react-jss'

export const FILTER_MARGIN = 5

export const style = {
  filter: {
    margin: `0 ${FILTER_MARGIN}px`
  },
  filterRow: {
    composes: 'flex-row',
    alignItems: 'flex-end'
  }
}

export const useStyles = createUseStyles(style)
